<template>
    <div class="box">
        <Titlebar
                :title="'扫码检测'"/>
        <video id="video" class="qrcode-video"/>
        <div class="note">
            请对准主控二维码扫描查看自检结果
        </div>
        <video-device-error placeholder="输入主控码" v-model="visible" prefix="https://machine.goldbox.vip/"
                            @submit="onDecode"/>
    </div>
</template>

<script>


    import Titlebar from "./Titlebar.vue"
    import videoDeviceError from "./videoDeviceError";

    import {isBoxNumber, parseBoxNumber} from "../util/utils.js"
    import {checkDoorStatus} from "../util/door.js"
    import {scanQrCode} from '../util/qrcode.js';

    export default {
        name: 'TestScan',
        data() {
            return {
                visible: false
            }
        },
        props: {},
        components: {
            Titlebar,
            videoDeviceError
        },
        mounted() {
            scanQrCode("video", this.onDecode, () => {
                this.visible = true;
            })
        },
        methods: {
            onDecode(boxNumber) {
                if (isBoxNumber(boxNumber)) {
                    var that = this
                    var number = parseBoxNumber(boxNumber)

                    checkDoorStatus(
                        number,
                        function (number) {
                            /* Add 2 seconds delay to open door */
                            setTimeout(function () {
                                var url = process.env.VUE_APP_API_SERVER + '/box/' + number + "/test-result"
                                var accessToken = localStorage.getItem('accessToken')

                                fetch(url, {
                                    method: "GET",
                                    headers: new Headers({
                                        'Content-Type': 'application/json',
                                        'Access-Token': accessToken
                                    })
                                }).then(res => {
                                    if (!res.ok) {
                                        throw res
                                    }
                                    return res.json()
                                }).catch(error => {
                                    sessionStorage.setItem("testResult", "failed")
                                    sessionStorage.setItem("testResultFailedReason", error)
                                    that.$router.go(-1)
                                }).then(response => {
                                    if (response.Status == 0) {
                                        if (response.Headers &&
                                            response.Headers["X-Oss-Meta-Upload-Type"] &&
                                            response.Headers["X-Oss-Meta-Upload-Type"].length > 0) {
                                            if (response.Headers["X-Oss-Meta-Upload-Type"][0] == "normal") {
                                                sessionStorage.setItem("testOkNumber", response.Tag)
                                                that.$router.push("/testok")
                                            } else {
                                                sessionStorage.setItem("testFailedUploadStatus", response.Headers["X-Oss-Meta-Upload-Type"][0])
                                                sessionStorage.setItem("testFailedNumber", response.Tag)
                                                that.$router.push("/testfailed")
                                            }
                                        } else {
                                            sessionStorage.setItem("testResult", "failed")
                                            sessionStorage.setItem("testResultFailedReason", "没有发现视频的头信息")
                                            that.$router.go(-1)
                                        }
                                    } else {
                                        sessionStorage.setItem("testFailedStatus", response.Status)
                                        sessionStorage.setItem("testFailedNumber", response.Tag)
                                        that.$router.push("/testfailed")
                                    }
                                })
                            }, 2000)
                        },
                        function (errorInfo) {
                            /* 检测不通过就重新开一次门，清空测试结果 */
                            that.openDoorAnyway(number)

                            sessionStorage.setItem("checkBoxFailedTitle", "无法通过测试")
                            sessionStorage.setItem("checkBoxFailedInfo", errorInfo)
                            that.$router.push("/checkBoxFailed")
                        },
                        function (notifyText) {
                            /* 检测不通过就重新开一次门，清空测试结果 */
                            that.openDoorAnyway(number)

                            sessionStorage.setItem("testResult", "failed")
                            sessionStorage.setItem("testResultFailedReason", notifyText)
                            that.$router.go(-1)
                        }
                    )
                } else {
                    sessionStorage.setItem("testResult", "failed")
                    sessionStorage.setItem("testResultFailedReason", "请扫描主控二维码")
                    this.$router.go(-1)
                }
            },
            openDoorAnyway(boxNumber) {
                var url = process.env.VUE_APP_API_SERVER + '/box/' + boxNumber + "/open-door"
                var accessToken = localStorage.getItem('accessToken')

                var that = this
                fetch(url, {
                    method: "POST",
                    headers: new Headers({
                        'Content-Type': 'application/json',
                        'Access-Token': accessToken
                    })
                }).then(res => {
                    if (!res.ok) {
                        throw res
                    }
                    return res.json()
                }).catch(error => {
                }).then(response => {
                })
            }
        }
    }
</script>

<style scoped>
    .note {
        margin-top: 20px;
        font-size: 20px;
        color: #666;
    }

    .box {
        width: 100%;
        height: 100%;
    }

    .qrcode-video {
        width: 100%;
        height: 50%;
        background-color: black;
    }
</style>
